import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Button } from '@mui/material';
import styled from 'styled-components';

const KebabButton = styled(Button)`
  min-width: 0;
  padding: 0.5rem 1rem;

  svg {
    height: 2rem;
  }
`;

const Kebab = () => {
  return (
    <KebabButton>
      <MoreVertIcon />
    </KebabButton>
  );
};

export default Kebab;
